<template>
    <div style="margin:0 -12px;">
        <HeaderMenu></HeaderMenu>
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <div style="padding:10px 0; overflow: hidden;" onclick="window.location.href = '/auth'">
                            <div class="item">
                                <svg style="height:36px;width:39px;fill:#5538EE;">
                                    <use xlink:href="/images/luna_logo.svg#luna_logo"></use>
                                </svg>
                            </div>
                            <div class="item">
                                <div class="logo" style="color: #5538EE;">Luna</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-end">
                        <div style="display: inline-flex;">
                            <div class="text-center" onclick="window.location.href = '/event/list'"
                                style="color:#5538EE;padding-top:7px;">
                                <svg style="height:25px;width:25px;fill:#5538EE;">
                                    <use xlink:href="/images/event_icon.svg#event_icon"></use>
                                </svg>
                                <div class="text-nowrap" style="font-size: 8px;">
                                    イベント情報
                                </div>
                            </div>
                            <div style="width:30px;"></div>
                            <a class="libere-header-menu text-center" data-bs-toggle="offcanvas" href="#offcanvasRight"
                                aria-controls="offcanvasRight" style="outline: none">
                                <div class="" style="color:#5538EE;padding-top:7px;">
                                    <svg style="height:25px;width:25px;fill:#5538EE;">
                                        <use xlink:href="/images/menu.svg#menu"></use>
                                    </svg>
                                    <div class="text-nowrap" style="font-size: 8px;">
                                        メニュー
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" style="padding-top:56px;">
            <div class="container-fluid" style="background:#FF2AA3;color:#fff">
                <div class="row">
                    <div class="col text-center" style="padding:15px 0;">
                        <small>
                            セキュリティーのため自動でログアウトされました。<br>
                            Lunaにログインしてください。
                        </small>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col px-0">
                        <img src="/images/Group13325.webp" class="img-fluid">
                    </div>
                </div>
                <div style="padding:12px 0;">
                    <div class="row justify-content-center">
                        <div class="col-9 px-0 text-center" style="font-weight: 600;">
                            <div style="color: #000;font-size: 16px;padding-bottom: 10px;">
                                ＼ 今すぐ無料ではじめよう！／
                            </div>
                            <div class="d-grid gap-2" style="padding: 0 5px;">
                                <a type="button" class="btn btn-luna" style="font-size:18px; padding:16px 0;" href="/auth">
                                    ログイン</a>
                            </div>
                            <div style="color: #000;font-size: 14px;padding: 10px 0;">
                                18歳未満の方はご登録いただけません
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col px-0">
                        <img src="/images/Group13327.webp" class="img-fluid">
                    </div>
                </div>
                <div class="row">
                    <div class="col px-0">
                        <div class="text-center">
                            <div class="text-center">
                                <img src="/images/Group13332.png" style="width:120px;">
                                <div style="margin-top: -130px;">
                                    <div style="padding:10px 0;font-size: 24px;font-weight: 600;">メディア掲載実績</div>
                                    <div style="padding:10px 0;font-size: 18px;font-weight: 600;">- MEDIA -</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <br>
                        <div style="font-size: 14px;">
                            ABEMAなどのTVやネットニュースをはじめ<br>
                            数多くのメディアで紹介・注目を浴びています
                        </div>
                        <br>
                        <br>
                        <img src="/images/Group13334.png" style="width:280px;">
                        <br>
                        <br>
                        <br>
                        <br>
                        <img src="/images/Group13228.png" style="width:300px;">
                        <br>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
                <div class="row" style="background-color:#9990FF;">
                    <div class="col px-0">
                        <div class="text-center">
                            <img src="/images/Group13328_.png" style="width:120px;">
                            <div style="margin-top: -130px;">
                                <div style="padding:10px 0;font-size: 24px;font-weight: 600;color:#fff;">Lunaの特徴</div>
                                <div style="padding:10px 0;font-size: 18px;font-weight: 600;color:#fff;">- FEATURE -</div>
                            </div>
                            <br>
                            <br>
                            <br>
                        </div>
                        <img src="/images/Group13335.png" class="img-fluid">
                    </div>
                </div>
                <div class="row">
                    <div class="col px-0">
                        <img src="/images/Group13336.png" class="img-fluid">
                        <br>
                        <br>
                        <div class="text-center">
                            <div style="font-size: 20px;">
                                <b>
                                    実際にイベントに参加して<br>
                                    同じ嗜好のユーザーと<br>
                                    交流しましょう！
                                </b>
                            </div>
                            <br>
                            <br>
                            <a type="button" class="btn btn-luna-outline"
                                style="font-weight: 600;font-size:18px; padding:12px 20px;background-color:#fff;color:#5538EE;border-width:2px;"
                                href="/event/list">
                                イベントページへ</a>
                            <br>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="row" style="background-color:#6B4EFF;">
                    <div class="col px-0">
                        <div class="text-center">
                            <img src="/images/Group13328_1.png" style="width:120px;">
                            <div style="margin-top: -130px;">
                                <div style="padding:10px 0;font-size: 24px;font-weight: 600;color:#fff;">使い方はかんたん！</div>
                                <div style="padding:10px 0;font-size: 18px;font-weight: 600;color:#fff;">- How to use -
                                </div>
                            </div>
                            <br>
                            <br>
                            <br>
                        </div>
                        <div class="overflow-scroll" style="padding:0 20px;">
                            <img src="/images/Group13337.png" style="height:300px;">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col px-0">
                        <div class="text-center">
                            <div class="text-center">
                                <img src="/images/Group13332.png" style="width:120px;">
                                <div style="margin-top: -130px;">
                                    <div style="padding:10px 0;font-size: 24px;font-weight: 600;">安心安全に使える理由</div>
                                    <div style="padding:10px 0;font-size: 18px;font-weight: 600;">- SAFE AND SECURE -</div>
                                </div>
                            </div>
                            <br>
                            <br>
                            <img src="/images/Group13338.png" style="width:80%;">
                            <br>
                            <br>
                            <a type="button" class="btn btn-luna-outline"
                                style="font-weight: 600;font-size:18px; padding:12px 20px;background-color:#fff;color:#5538EE;border-width:2px;"
                                href="/pages/safety">
                                セーフティーページへ</a>
                            <br>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="row" style="background-color:#E7E7FF;">
                    <div class="col px-0">
                        <div class="text-center">
                            <img src="/images/Group13328.png" style="width:120px;">
                            <div style="margin-top: -130px;">
                                <div style="padding:10px 0;font-size: 24px;font-weight: 600;">よくある質問</div>
                                <div style="padding:10px 0;font-size: 18px;font-weight: 600;">- QUESTION -</div>
                            </div>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center" style="background-color:#E7E7FF;">
                    <div class="col-10">
                        <details class="err_accordion" style="margin-bottom:10px;">
                            <summary class="err_accordion__title">
                                <span style="color:#6B4EFF">Q.</span>&nbsp;<b>無料で利用できますか？</b>
                            </summary>
                            <div class="err_accordion__content">
                                <div class="err_accordion__content_box">
                                    <div class="row">
                                        <div class="col-1 text-end px-0">
                                            A.
                                        </div>
                                        <div class="col">
                                            男性、女性ともに完全無料で利用できます。他サービスと違いメッセージまで含め無料で利用できます。有料はさらに活用をしたい方が利用できます。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>
                        <details class="err_accordion" style="margin-bottom:10px;">
                            <summary class="err_accordion__title">
                                <span style="color:#6B4EFF">Q.</span>&nbsp;<b>サクラはいませんか？</b>
                            </summary>
                            <div class="err_accordion__content">
                                <div class="err_accordion__content_box">
                                    <div class="row">
                                        <div class="col-1 text-end px-0">
                                            A.
                                        </div>
                                        <div class="col">
                                            いわゆるサイト側で用意するような女性のサクラは一切おりません。<br>
                                            そもそも無料で利用が出来るのでサクラが必要ありません。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>
                        <details class="err_accordion" style="margin-bottom:10px;">
                            <summary class="err_accordion__title">
                                <span style="color:#6B4EFF">Q.</span>&nbsp;<b>トラブルに巻き込まれないか心配です</b>
                            </summary>
                            <div class="err_accordion__content">
                                <div class="err_accordion__content_box">
                                    <div class="row">
                                        <div class="col-1 text-end px-0">
                                            A.
                                        </div>
                                        <div class="col">
                                            トラブルに巻き込まれないよう、セーフティーページのご用意や、Luna運営の相談窓口もご用意しております。いつでも頼ってください。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>
                        <details class="err_accordion" style="margin-bottom:10px;">
                            <summary class="err_accordion__title">
                                <span style="color:#6B4EFF">Q.</span>&nbsp;<b>誰でも登録できますか？</b>
                            </summary>
                            <div class="err_accordion__content">
                                <div class="err_accordion__content_box">
                                    <div class="row">
                                        <div class="col-1 text-end px-0">
                                            A.
                                        </div>
                                        <div class="col">
                                            高校生を除く18歳以上の方であれば、誰でもご登録をいただけます。<br>
                                            すべての機能の利用をするには、法律で身分証の提出が必須なのでご了承ください。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>
                        <details class="err_accordion" style="margin-bottom:10px;">
                            <summary class="err_accordion__title">
                                <span style="color:#6B4EFF">Q.</span>&nbsp;<b>身バレはしませんか？</b>
                            </summary>
                            <div class="err_accordion__content">
                                <div class="err_accordion__content_box">
                                    <div class="row">
                                        <div class="col-1 text-end px-0">
                                            A.
                                        </div>
                                        <div class="col">
                                            ご自身で個人情報を記載いただかない限り、電話番号やメールアドレスでの紐付けなどは行っておりませんので、知らず知らずにお知り合いの方へ身バレすることはございません。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
            </div>
        </div>
        <FooterLogin></FooterLogin>
    </div>
</template>

<script>
import HeaderMenu from './HeaderMenu.vue'
import FooterLogin from './FooterLogin.vue'

export default {
    data() {
        return {
            visible: false,
        };
    },
    components: {
        HeaderMenu: HeaderMenu,
        FooterLogin: FooterLogin,
    },
}


const ANIMATION_TIME = 250;
const OFFSET_TIME = 5;

document.addEventListener('DOMContentLoaded', function () {
    const err_accordions = document.querySelectorAll('.err_accordion');
    err_accordions.forEach((err_accordion) => {
        const title = err_accordion.querySelector('.err_accordion__title');
        const content = err_accordion.querySelector('.err_accordion__content');

        // summary クリックイベント
        title.addEventListener('click', (e) => {
            // すぐに open 属性が切り替わらないようにする
            e.preventDefault();

            // タイトル部分の高さを取得。（ブラウザ幅が変更されて高さが変わった場合などにも対応できるようにクリックイベントの中で高さを毎回取得）
            const titleHeight = title.offsetHeight;

            // 閉じる時の高さ = タイトル部分の高さ
            err_accordion.style.setProperty('--acc-height--closed', `${titleHeight}px`);

            // オープン / クローズ 処理
            if (!err_accordion.open) {
                // open属性を最初にセット
                err_accordion.open = true;

                // ※ コンテンツの高さはopenを付けたあとで取得しないと iOSで０になる
                err_accordion.style.setProperty('--acc-height--opened', `${titleHeight + content.offsetHeight}px`);

                // open付与から少しだけ遅らせた方が動作が安定する
                setTimeout(() => {
                    err_accordion.classList.add('is-opened'); // クラスの追加
                }, OFFSET_TIME);
            } else if (err_accordion.open) {

                // 初期状態で開いているアコーディオンもアニメーションするように、閉じるときにもセット
                err_accordion.style.setProperty('--acc-height--opened', `${titleHeight + content.offsetHeight}px`);

                setTimeout(() => {
                    err_accordion.classList.remove('is-opened'); // クラスを削除
                }, OFFSET_TIME);

                // アニメーション完了後にopen属性を削除。（CSS側のアニメーション時間+少しだけ余裕をもたせている）
                setTimeout(() => {
                    err_accordion.open = false;
                }, ANIMATION_TIME + OFFSET_TIME);
            }
        });

        // details 'toggle' イベント
        err_accordion.addEventListener('toggle', () => {
            // is-opened クラスを持つかどうか
            const hasOpenedClass = err_accordion.classList.contains('is-opened');

            if (err_accordion.open && !hasOpenedClass) {
                // open はセットされたのに is-opened クラスがついてない時
                err_accordion.classList.add('is-opened');
            } else if (!err_accordion.open && hasOpenedClass) {
                // open は削除されたのに is-opened クラスがまだついている時
                err_accordion.classList.remove('is-opened');
            }
        });
    });
});

</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=MuseoModerno:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans+SC:wght@700&display=swap');

a {
    color: #fff;
}

.err_accordion {
    overflow: hidden;
    height: var(--acc-height--closed, auto);
    transition: height .25s;
    box-sizing: border-box;

    &.is-opened {
        height: var(--acc-height--opened, auto);
    }
}

.err_accordion+.err_accordion {
    margin-top: -1px;
}

/* display:list-item 以外にしてデフォルトの三角アイコンを非表示にする */
.err_accordion__title {
    display: block;
    align-items: center;
    justify-content: space-between;
    padding: 1em;
    background: #fff;
    cursor: pointer;
    border-radius: 10px;
    border: 0;
}

/* Safariで表示されるデフォルトの三角形アイコンを削除 */
.err_accordion__title::-webkit-details-marker {
    display: none;
}

.err_accordion__title::after {
    content: "";
    width: 1em;
    height: 1em;
    margin: 0 .5em;
    background-color: currentColor;
    clip-path: polygon(50% 80%, 0 20%, 100% 20%);
    transition: transform .25s;
}

.err_accordion__title::before {
    display: flex;
    float: right;
    content: url("/images/+.svg");
}

.err_accordion.is-opened>.err_accordion__title::after {
    transform: rotate(180deg);
    display: contents;
    float: right;
    content: "";
    border-radius: 10px 10px 0 0px;
}

.err_accordion.is-opened>.err_accordion__title::before {
    display: flex;
    float: right;
    content: "";
}

.err_accordion.is-opened>.err_accordion__title::-webkit-details-marker {
    display: none;
}

.err_accordion__content {
    padding-top: 16px;
    background-color: #fff;
    border-radius: 0 0px 10px 10px;
    margin-top: -10px;
}

.err_accordion__content[open] .err_accordion__title:after {
    display: none;
}

.err_accordion__content_box {
    padding: 20px;
    border-radius: 10px;
    background-color: #9990FF;
    color: #fff;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}


.item {
    float: left;
}

.logo {
    font-size: 30px;
    line-height: 30px;
    padding-top: 5px;
    padding-left: 5px;
}

.login-box {
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    padding: 25px;
}

.card_box {
    width: 150px;
    right: 70px;
    top: 60px;
    position: absolute;
    background: rgba(106, 77, 255, 0.7);
    padding: 15px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
}

.card_box:after {
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    pointer-events: none;
    position: absolute;
    border-color: rgba(247, 221, 51, 0);
    border-top-width: 12px;
    border-bottom-width: 12px;
    border-left-width: 5px;
    border-right-width: 5px;
    margin-left: -5px;
    border-bottom-color: rgba(106, 77, 255, 0.7);
    ;
    bottom: 100%;
    left: 79%;
}

.card_anim {
    animation: fadeOut .5s linear;
    animation-fill-mode: forwards;
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>
